import React, { Component } from 'react';
import './App.css';
import { LoginView } from './views/Login';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import Appointments from './views/Appointments';

import AppConfirm from './views/AppConfirm';

import 'semantic-ui-css/semantic.min.css';

import {BioTrackPortal, BioDropDown} from './components/BiopedUI';
import AccountService from './api/services/AccountService';
import PersistentData from './api/PersistentData';

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import AutoCompleteInput from './components/AutoCompleteInput';
import { Input } from './components/FormUI';
import AssessmentReport from './views/Assessment/AssessmentReport';
import RegionSelectList, { RegionController, CountrySelectList, DistrictSelectList, CitySelectList } from './components/datalists/RegionSelectLists';
import dev from './views/dev';
//import RootModal from './components/RootModal';
import settings from './config';

import 'ag-grid-community/dist/styles/ag-grid.css';
import './views/pending/ag-bioped-theme.css';
import pjson from '../package.json';

function popGET(){
	var search = window.location.search.substr(1);
	search = search.split("&");
	window.$_GET = {};
	for(var i=0; i < search.length; i++){
		var itm = search[i].split("=");
		if(itm.length == 2)window.$_GET[itm[0].trim()] = itm[1].trim();
	}
}

popGET();


//appstatus=confirm&secret=somestring&appointmentId=2323

const queryParams = window.$_GET;
const rc = new RegionController();
class App extends Component {
	constructor(props){
		super(props);
		this.state = {
			authToken: null
		}

		this.AppData = new PersistentData("AppInfo");

		console.log(`React App Name - ${process.env.REACT_APP_NAME} Version: ${process.env.REACT_APP_VERSION}`)
		let ver = pjson.version;// '2.73a';
		if(this.AppData.getData('version') !== ver){
			window.localStorage.clear();
			this.AppData.setData('version', ver);
		}


		window.logout = () => {
			let ac = new AccountService();
			ac.logout();
		}

		window.addEventListener('popstate', function(event) {
			console.log('Window.Popstate:', event)
			//history.go(1);
		});

		window.addEventListener('beforeunload', function(e){
			e.preventDefault();
			e.returnValue = 'Are you Sure?';
			console.log("before unload");
			return 'Are you Sure?';
		})


	}

	render() {


		/*return(
			<div>
			  <CountrySelectList controller={rc} />
			  <DistrictSelectList controller={rc} />
			  <CitySelectList controller={rc} />
			</div>

		)*/

		return (
			<Router>
				<div>
					<Route exact path="/" component={LoginView} />
					<Route path="/appointments" component={Appointments} />
					<Route path="/confirmed" component={AppConfirm} />
					<Route path="/cancelled" component={AppConfirm} />
					<Route path="/dev" component={dev} />
					<NotificationContainer />
					<div className="app-version">apiPath: { settings.apiPath } - v{ this.AppData.getData('version') }</div>
				</div>
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js